import { styled } from 'styled-components';

import { NavigationButton } from 'app/components/navigation-button';
import { breakpointTablet } from 'app/style/breakpoints';
import { colorBorder, colorNeutral } from 'app/style/colors';
import { spacing1, spacing2, spacing3, spacing5 } from 'app/style/spacing';

export const StyledCard = styled.div`
    border: 1px solid ${colorBorder};
    box-sizing: border-box;
    box-shadow: 0 4px 4px rgb(0 0 0 / 25%);
    border-radius: 2px;
    padding: ${spacing2} ${spacing1} ${spacing3};
    max-width: 360px;
    background-color: ${colorNeutral};

    @media (min-width: ${breakpointTablet}) {
        min-width: 358px;
        padding: ${spacing3} ${spacing3} ${spacing5} ${spacing3};
    }
`;

export const StyledButton = styled(NavigationButton)`
    margin: 0 auto;
`;
